<template>
  <div>
    <validation-observer ref="signPlanFormRef">
      <validation-provider v-slot="{ errors }" rules="required|validOption">
        <div
          class="d-flex flex-column flex-md-row align-items-start align-items-md-center border-bottom"
        >
          <div class="flex-grow-1">
            {{ questionLabel }}
            <custom-error
              v-if="errors[0]"
              class="ml-n1"
              message="Favor de seleccionar una opción."
              variant="no-border"
            />
          </div>
          <custom-radio
            ref="question"
            v-model="questionAnswer"
            :change-event="handleChangeEventOption"
            class="custom-radio__extended mt-3 mt-md-0"
            container-class="custom-radio-center"
            custom-error-msg="''"
            :disabled="disabled"
            is-question-list
            name="question-1"
            :options="mechanismOptions"
          />
        </div>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import CustomRadio from 'custom-radio';
import CustomError from 'custom-error';

extend('validOption', {
  validate(value) {
    return (
      value &&
      typeof value === 'object' &&
      'value' in value &&
      [true, false].includes(value.value)
    );
  },
  message: 'Favor de seleccionar una opción válida.',
});

export default {
  name: 'SignPlan',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomRadio,
    CustomError,
  },
  props: {
    isElectronicSignature: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    questionLabel: {
      type: String,
      default:
        '¿Cuál será el mecanismo que se estará utilizando para firmar el Plan de Intervención?',
    },
  },
  data() {
    return {
      questionAnswer: {},
      mechanismOptions: [
        {
          name: 'answer1',
          label: 'Electrónica',
          value: true,
        },
        {
          name: 'answer2',
          label: 'Manuscrito',
          value: false,
        },
      ],
    };
  },
  computed: {},
  watch: {
    isElectronicSignature: {
      handler(val) {
        this.setSelectedQuestion(val);
      },
    },
  },
  mounted() {
    this.setSelectedQuestion(this.isElectronicSignature);
  },
  methods: {
    async validate() {
      return await this.$refs.signPlanFormRef.validate();
    },
    handleChangeEventOption(value) {
      const selectedValue = value ? value.value : null;
      if (selectedValue !== this.isElectronicSignature) {
        this.$emit('update:isElectronicSignature', selectedValue);
        this.$emit('change', value);
      }
    },
    setSelectedQuestion(val) {
      if (val === true) {
        this.questionAnswer = this.mechanismOptions[0];
      } else if (val === false) {
        this.questionAnswer = this.mechanismOptions[1];
      } else {
        this.questionAnswer = {};
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
::v-deep .custom-radio__extended {
  .custom-radio-container {
    .radio-button {
      border: unset;
      background: map-get($colors, 'secondary-9') !important;
      width: 120px !important;
      height: 70px !important;
      flex-shrink: 0 !important;
      .radio {
        margin-top: 10px;
      }
      .step-label {
        font-size: 12px;
        color: map-get($colors, 'gray-8');
      }
    }
    .radio-button.bg-checked {
      background: map-get($colors, 'secondary-22') !important;
      .step-label {
        color: map-get($colors, 'white') !important;
      }
      .rounded-circle {
        border-color: map-get($colors, 'white');
        i {
          color: map-get($colors, 'white');
          top: -5px;
        }
      }
    }
  }
}
</style>
